import { fromJS } from 'immutable';
import { createReducer } from '../../utils/helpers';
import { latestCases } from './types';

const initialState = fromJS({
  data: null,
  loading: true,
  error: false,
});

export default createReducer(initialState, {
  [latestCases.request]: (state) => state.set('loading', true),
  [latestCases.success]: (state, action) =>
    state.set('loading', false).set('error', false).set('data', action.response),
  [latestCases.failure]: (state, action) => state.set('loading', false).set('error', action.error),
});
